import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const VariantPurchaseGroup: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        marginBottom: pxToRem(73),
        [`&:empty`]: {
            display: 'none',
        },
    },
});
